module.exports = __webpack_public_path__ + "static/media/manage2.c4c69b66.jpg";